<section class="flex justify-between items-center mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Cierres de caja</h1>
    @if(canCreate){
    <add-button label="Cerrar caja" (onClick)="openForm()"></add-button>
    }
</section>

<sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" pageParamName="page"
    contentTotal="total" [sizeInitialPage]="1" limitParamName="limit" [sizeBetweenPages]="1" [limit]="10"
    [headers]="headers" (showEvent)="openForm($event)" (printEvent)="print($event)" [canDelete]="canDelete" (deleteEvent)="openDeleteForm($event)"
    [customTemplates]="{ 'total_sales': totalSalesTmpl, 'expected_cash': expectedTmpl, 'counted_cash': countedTmpl, 'difference': differenceTmpl }">

    <ng-template #totalSalesTmpl let-item="item"><span [centToEurDisplay]="item.total_sales"></span></ng-template>
    <ng-template #expectedTmpl let-item="item"><span [centToEurDisplay]="item.expected_cash"></span></ng-template>
    <ng-template #countedTmpl let-item="item">
        @if(item.counted_cash !== null){ <span [centToEurDisplay]="item.counted_cash"></span> }
        @else { <span class="text-gray-400">sin contar</span> }
    </ng-template>
    <ng-template #differenceTmpl let-item="item">
        @if(item.difference !== null){
        <span class="font-semibold" [class.text-green-600]="item.difference === 0" [class.text-red-600]="item.difference < 0"
            [class.text-amber-600]="item.difference > 0" [centToEurDisplay]="item.difference"></span>
        } @else { <span class="text-gray-400">—</span> }
    </ng-template>

</sau-table>
